// Module
var code = "<div ng-class=\"{'pr-0': isMobile}\"> <runner-page-description help-link=\"{{$ctrl.helpUri}}\" back-link-text=\"Form Themes\" back-link-state=\"{{$ctrl.stateMappings.libraryFormThemes}}\"> </runner-page-description> <form-theme-editor form-theme-id=\"$ctrl.formThemeId\" copy=\"$ctrl.copy\"> </form-theme-editor> </div> ";
// Exports
export default code;